import React, { useCallback, useMemo } from 'react';

import { View } from 'react-native';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { NetInfoStateType } from '@react-native-community/netinfo';

import Checkmark from 'assets/images/svgs/ico_checkmark.svg';

import gStyles from 'config/styles';

import { selectLayoutConfig } from 'store/config/selectors';
import { setConnectionType } from 'store/user/actions';
import { selectConnectionType } from 'store/user/selectors';

import SettingsRowItem from '../components/RowItem';
import {
    SETTINGS_RN_INTERNET_CONNECTION_WIFI_AND_MOBILE_DATA,
    SETTINGS_RN_INTERNET_CONNECTION_WIFI_ONLY,
} from '../languagesConst';
import { SimpleSettingsItem } from '../types';

function InternetConnection() {
    const { background } = useSelector(selectLayoutConfig);
    const connectionType = useSelector(selectConnectionType);
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const menuOptions = useMemo<SimpleSettingsItem[]>(
        () => [
            {
                id: NetInfoStateType.wifi,
                title: t(SETTINGS_RN_INTERNET_CONNECTION_WIFI_ONLY),
                testID: SETTINGS_RN_INTERNET_CONNECTION_WIFI_ONLY,
            },
            {
                id: NetInfoStateType.cellular,
                title: t(SETTINGS_RN_INTERNET_CONNECTION_WIFI_AND_MOBILE_DATA),
                testID: SETTINGS_RN_INTERNET_CONNECTION_WIFI_AND_MOBILE_DATA,
            },
        ],
        [t],
    );

    const handlePress = useCallback(
        (item: SimpleSettingsItem) => {
            if (item.id !== connectionType) {
                dispatch(setConnectionType(item.id as NetInfoStateType));
            }
        },
        [connectionType, dispatch],
    );

    return (
        <>
            <View
                style={[
                    gStyles.settingsContainer,
                    { backgroundColor: background },
                ]}
            >
                <View
                    style={[
                        gStyles.settingsContentContainer,
                        { backgroundColor: background },
                    ]}
                >
                    {menuOptions.map((item, index) => (
                        <SettingsRowItem
                            key={item.id}
                            item={item}
                            title={item.title}
                            RightIcon={
                                connectionType === item.id
                                    ? Checkmark
                                    : undefined
                            }
                            testID={item.testID}
                            onPress={handlePress}
                            position={index + 1}
                            total={menuOptions.length}
                            isSelected={connectionType === item.id}
                        />
                    ))}
                </View>
            </View>
        </>
    );
}

export default InternetConnection;
